export default function(container: HTMLDivElement): void {
    const orderTypeCheckboxes = container.querySelectorAll('.order-type-checkbox') as NodeListOf<HTMLInputElement>|null;
    const allCheckBox = container.querySelector('#checkbox-all') as HTMLInputElement|null;

    if (orderTypeCheckboxes === null || allCheckBox === null) {
        return;
    }

    // If 'ALL' is checked, unselect all other checkboxes
    allCheckBox.addEventListener('change', () => {
        if (allCheckBox.checked) {
            orderTypeCheckboxes.forEach((input, index) => {
                input.checked = false;
            })
        }
    })

    // If any other checkbox is selected, unselect 'ALL'
    orderTypeCheckboxes.forEach((orderType) => {
        orderType.addEventListener('change', () => {
            if (orderType.checked) {
                allCheckBox.checked = false;
            }
        })
    })
}
